import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {DemoDashboardComponent} from "./demo-dashboard.component";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'demo-dashboard',
                component: DemoDashboardComponent,
                resolve: {}
            }
        ])
    ],
    exports: [RouterModule]
})
export class DemoDashboardRoutingModule {}